import { TimelineMax, Power2 } from 'gsap';
import { CbsBasicsComponent } from './/cbs-basics.component';
import * as _ from 'lodash' ;
import * as d3 from 'd3';

export class BasicChartComponent extends CbsBasicsComponent {

  public scaleX: any;
  public scaleXInner: any;
  public scaleY: any;
  public lineString: string;
  public id: string;

  public dataValues;
  public indices;

  constructor(iconService) {
    super(iconService);
  }

  public ngOnInit() {
    super.ngOnInit();
  }

  public async calculateValues() {
    super.calculateValues();
    this.values['bannerHeight'] = (this.values['bannerHeight'] === null || this.values['bannerHeight'] === undefined) ? (this.values['titleText2'] && this.values['titleText2'] !== '' ? 3 * this.values['titleFontSize'] : (this.values['titleText1'] && this.values['titleText1'] !== '' ? 1.8 * this.values['titleFontSize'] : 0)) : this.values['bannerHeight'];
    this.values['backgroundPaneHeight'] = this.values['height'] - this.values['bannerHeight'];
    this.values['chartPaneX'] = this.values['marginLeft'];
    this.values['chartPaneY'] = this.values['bannerHeight'] + this.values['marginTop'];
    this.values['chartPaneWidth'] = this.values['width'] - this.values['marginLeft'] - this.values['marginRight'] - (this.values['paddingRight'] ? this.values['paddingRight'] : 0);
    this.values['chartPaneHeight'] = this.values['height'] - this.values['bannerHeight'] - this.values['marginTop'] - this.values['marginBottom'];
    this.values['chartDomainX'] = this.values['chartPaneX'] + this.values['labelSpaceY'];
    this.values['chartDomainY'] = this.values['chartPaneY'];
    this.values['chartDomainWidth'] = this.values['chartPaneWidth'] - this.values['labelSpaceY'];
    this.values['chartDomainHeight'] = this.values['chartPaneHeight'] - this.values['labelSpaceX'];
    // this.showDebugValues()
  }

  public createLineScales(data, values) {

    let valueData = _.filter(data, function(n) {
      return typeof (n[0]) !== 'string';
    });

    // Whatever the size of the rows array only take the first column
    let list = _.map(valueData, a => a[0]);
    let indices = _.range(list.length);

    // Start and end x-coordinates [x1, x2]
    // let rangeX = [values['chartDomainX'] - values['axisStrokeWidth'] / 2, values['chartDomainX'] + values['chartDomainWidth']];
    let rangeX = [values['chartDomainX'], values['chartDomainX'] + values['chartDomainWidth']];
    // Ordinal scale in steps without band width
    this.scaleX = d3.scalePoint()
      // min and max value from the data (source)
      .domain(indices)
      // values in the plot to map the domain to (dest)
      .range(rangeX);

    // Start and end y-coordinates [y1, y2] NB y1 > y2

    let rangeY = [values['chartDomainY'] + values['chartDomainHeight'] + values['axisStrokeWidth'] / 2, values['chartDomainY']];

    this.scaleY = d3.scaleLinear()
      .domain([values['minY'], values['maxY']])
      .range(rangeY);
  }

  public createBarScales(data, values) {
    // Whatever the size of the rows array only take the first column
   let dataBar = [];
   let rowData = data[0]  === '' || data[0][0] === '' || typeof (data[0]) !== 'string' ? _.drop(data, 1) : data;
   _.map(rowData, function (val) {
     dataBar.push(val);
   });

    let list = _.map(dataBar, a => a[0]);
    let indices = _.range(list.length);

    // Start and end x-coordinates [x1, x2]
    let rangeX = [values['chartDomainX'] - values['axisStrokeWidth'] / 2, values['chartDomainX'] + values['chartDomainWidth']];

    // Ordinal scale in steps without band width
    this.scaleX = d3.scaleBand()
      // min and max value from the data (source)
      .domain(indices)
      // values in the plot to map the domain to (dest)
      .rangeRound(rangeX)
      .padding(values['barPadding']);
    // Start and end y-coordinates [y1, y2] NB y1 > y2
    let rangeY = [values['chartDomainY'] + values['chartDomainHeight'] + values['axisStrokeWidth'] / 2, values['chartDomainY']];

    this.scaleY = d3.scaleLinear()
      .domain([values['minY'], values['maxY']])
      .range(rangeY);
  }

  public createHorizontalBarScales(data, values) {
    // Whatever the size of the rows array only take the first column
    let list = _.map(data, a => a[0]);
    let indices = _.range(list.length);

    // Start and end x-coordinates [x1, x2]
    let rangeX = [values['chartDomainX'] - values['axisStrokeWidth'] / 2, values['chartDomainX'] + values['chartDomainWidth']];


    this.scaleX = d3.scaleLinear()
      .domain([values['minX'], values['maxX']])
      .range(rangeX);

    // Start and end y-coordinates [y1, y2] NB y1 > y2
    let rangeY = [values['chartDomainY'], values['chartPaneY'] + values['chartDomainHeight']];

    this.scaleY = d3.scaleBand()
      .domain(indices)
      .rangeRound(rangeY)
      .padding(values['barPadding']);

  }

  public drawPositioningGuides(selection, values) {
    selection.append('rect')
      .attr('id', `chartPane-${this.id}`)
      .attr('x', values['chartPaneX'])
      .attr('y', values['chartPaneY'])
      .attr('width', values['chartPaneWidth'])
      .attr('height', values['chartPaneHeight'])
      .attr('fill', 'yellow')
      .attr('visibility', 'hidden');
    selection.append('rect')
      .attr('id', `chartDomain-${this.id}`)
      .attr('x', values['chartDomainX'])
      .attr('y', values['chartDomainY'])
      .attr('width', values['chartDomainWidth'])
      .attr('height', values['chartDomainHeight'])
      .attr('fill', 'red')
      .attr('visibility', 'hidden');
  }

  public drawIconWatersign(selection, values) {
    if (values['iconShow']) {
      let g = selection.append('g')
        .attr('id', `icon-${this.id}`);
      let inner = this.iconService.getIcon(values['icon'], 'binnenvorm', {
        'x': values['iconOffsetX'],
        'y': values['iconOffsetY'],
        'width': values['iconWidth'],
        'preserveAspectRatio': 'xMinYMin'
      }, { 'fill': values['colorScheme']['value'][0], 'stroke': 'none' });
      let outer = this.iconService.getIcon(values['icon'], 'buitenvorm', {
        'x': values['iconOffsetX'],
        'y': values['iconOffsetY'],
        'width': values['iconWidth'],
        'preserveAspectRatio': 'xMinYMin'
      }, { 'fill': '#ffffff', 'stroke': 'none' });
      selection.append(outer).attr('id', `icon-svg-outer-${this.id}`);
      selection.append(inner).attr('id', `icon-svg-inner-${this.id}`);
      return selection;
    }
  }

  public drawXAxis(selection, values) {
    let xAxis = selection.append('line')
      .attr('id', `xAxis-${this.id}`)
      .attr('x1', values['chartDomainX'] - values['axisStrokeWidth'] / 2)
      .attr('x2', values['chartDomainX'] + values['chartDomainWidth'])
      .attr('stroke', values['axisStroke'])
      .attr('stroke-width', values['axisStrokeWidth']);
    // If minY is 0 or greater draw the X axis at the bottom
    if (values['minY'] >= 0) {
      xAxis.attr('y1', values['chartDomainY'] + values['chartDomainHeight'])
        .attr('y2', values['chartDomainY'] + values['chartDomainHeight']);
      // If maxY is 0 or less draw the X axis at the top
    } else if (values['maxY'] < 0) {
      xAxis.attr('y1', values['chartDomainY'])
        .attr('y2', values['chartDomainY']);
      // If 0 is between minY and maxY draw a 0 axis
    } else {
      xAxis.attr('y1', this.scaleY(0))
        .attr('y2', this.scaleY(0));
    }
  }

  public drawYAxis(selection, values) {
    // Y Axis
    if (values['drawYAxis']) {
      if (values['minY'] > 0) {
        // Draw wiggly line at the bottom
        let zZW = values['zigZagWidth'];
        let zZH = values['zigZagHeight'];
        let zZN = values['zigZagNumber'];
        let startX = values['chartDomainX'];
        let startY = values['chartDomainY'] + values['chartDomainHeight'] + values['axisStrokeWidth'] / 2;
        let d = `M${startX},${startY} l0,${-zZH}`;
        let wiggles = _.map(_.range(0, zZN), i => `l${-0.5 * zZW},${-0.25 * zZH} l${zZW},${-0.5 * zZH} l${-0.5 * zZW},${-0.25 * zZH}`).join(' ');
        d = d + wiggles;
        let height = values['chartDomainHeight'] + values['axisStrokeWidth'] / 2;
        let remainder = height - zZH * (zZN + 1);
        d = d + `l0,${-remainder}`;
        selection.append('path')
          .attr('id', `yAxis-${this.id}`)
          .attr('d', d)
          .attr('stroke', values['axisStroke'])
          .attr('stroke-width', values['axisStrokeWidth'])
          .attr('fill', 'none');
      } else if (values['maxY'] < 0) {
        // Draw wiggly line at the top
        let zZW = values['zigZagWidth'];
        let zZH = values['zigZagHeight'];
        let zZN = values['zigZagNumber'];
        let startX = values['chartDomainX'];
        let startY = values['chartDomainY'] + values['chartDomainHeight'] + values['axisStrokeWidth'] / 2;
        let height = values['chartDomainHeight'] + values['axisStrokeWidth'] / 2;
        let remainder = height - zZH * (zZN + 1);
        let d = `M${startX},${startY} l0,${-remainder}`;
        let wiggles = _.map(_.range(0, zZN), i => `l${-0.5 * zZW},${-0.25 * zZH} l${zZW},${-0.5 * zZH} l${-0.5 * zZW},${-0.25 * zZH}`).join(' ');
        d = d + wiggles;
        d = d + `l0,${-zZH}`;
        selection.append('path')
          .attr('id', `yAxis-${this.id}`)
          .attr('d', d)
          .attr('stroke', values['axisStroke'])
          .attr('stroke-width', values['axisStrokeWidth'])
          .attr('fill', 'none');
      } else {
        // draw Y axis without wiggly line
        selection.append('line')
          .attr('id', `yAxis-${this.id}`)
          .attr('x2', values['chartDomainX'])
          .attr('y2', values['chartDomainY'])
          .attr('x1', values['chartDomainX'])
          .attr('y1', values['chartDomainY'] + values['chartDomainHeight'] + values['axisStrokeWidth'] / 2)
          .attr('stroke', values['axisStroke'])
          .attr('stroke-width', values['axisStrokeWidth']);
      }
    }
  }

  public drawYAxisLabels(selection, values) {
    if (values['drawYAxis']) {
      let bottomText = selection.append('text')
        .attr('id', `yAxisBottomValue-${this.id}`)
        .attr('x', values['chartDomainX'] - values['labelOffsetY'])
        .attr('text-anchor', 'end')
        .attr('fill', values['labelColor'])
        .attr('font-size', values['labelFontSize'])
        .attr('font-family', values['labelFontFamily'] || 'Akko, Akko W01 Regular')
        .text(this.formatNumberDecimals(values['minY'], values['labelDecimalsY'], values['formatLocale']['value'], ));
      if (values['minY'] > 0) {
        bottomText.attr('y', values['chartDomainY'] + values['chartDomainHeight'] - (values['zigZagNumber'] + 1) * values['zigZagHeight'])
      } else {
        bottomText.attr('y', values['chartDomainY'] + values['chartDomainHeight'])
      }
      let topText = selection.append('text')
        .attr('id', `yAxisTopValue-${this.id}`)
        .attr('x', values['chartDomainX'] - values['labelOffsetY'])
        .attr('text-anchor', 'end')
        .attr('dy', '0.7em')
        .attr('fill', values['labelColor'])
        .attr('font-size', values['labelFontSize'])
        .attr('font-family', values['labelFontFamily'] || 'Akko, Akko W01 Regular')
        .text(this.formatNumberDecimals(values['maxY'], values['labelDecimalsY'], values['formatLocale']['value'], ));
      if (values['maxY'] < 0) {
        topText.attr('y', values['chartDomainY'] + (values['zigZagNumber'] + 1) * values['zigZagHeight'])
      } else {
        topText.attr('y', values['chartDomainY'])
      }
    }
  }

  public drawXAxisSteps(selection, values, data) {
    let g = selection.append('g')

    let xAxis = g.append('line')
      .attr('id', `xAxis-${this.id}`)
      .attr('x1', values['chartDomainX'] - values['axisStrokeWidth'] / 2)
      .attr('x2', values['chartDomainX'] + values['chartDomainWidth'])
      .attr('stroke', values['colorScheme']['value'][1])
      .attr('stroke-width', values['axisStrokeWidth']);
    // If minY is 0 or greater draw the X axis at the bottom
    if (values['minY'] >= 0) {
      xAxis.attr('y1', values['chartDomainY'] + values['chartDomainHeight'])
        .attr('y2', values['chartDomainY'] + values['chartDomainHeight']);
      // If maxY is 0 or less draw the X axis at the top
    } else if (values['maxY'] < 0) {
      xAxis.attr('y1', values['chartDomainY'])
        .attr('y2', values['chartDomainY']);
      // If 0 is between minY and maxY draw a 0 axis
    } else {
      xAxis.attr('y1', this.scaleY(0))
        .attr('y2', this.scaleY(0));
    }

    values['step'] = (values['maxY'] - values['minY']) / (values['steps']);

    let y0Label = values['maxY'] < 0 ? values['maxY'] : values['minY'] > 0 ? values['minY'] : 0;

    let yLabelAs = g.append('text')
      .attr('id', `step-label0-${this.id}`)
      .attr('text-anchor', 'end')
      .attr('x', values['chartDomainX'] - values['labelOffsetY'])
      .attr('y', this.scaleY(y0Label))
      .attr('dominant-baseline', 'middle')
      .attr('fill', values['labelColor'])
      .attr('font-size', values['labelFontSize'])
      .attr('font-family', values['labelFontFamily'] || 'Akko, Akko W01 Regular')
      .text(this.formatNumberDecimals(y0Label, values['labelDecimalsY'], values['formatLocale']['value']));

  }

  public drawSteps(selection, values, data) {
    let g = selection.append('g');
    let y0Label = values['maxY'] < 0 ? values['maxY'] : values['minY'] > 0 ? values['minY'] : 0;
    values['step'] = (values['maxY'] - values['minY']) / (values['steps']);
    for (let idx: number = 1; idx <= values['steps']; idx++) {
      let yValue;
      let steps = g.append('line')
        .attr('id', `step${idx}-${this.id}`)
        .attr('x1', values['chartDomainX'] - values['axisStrokeWidth'] / 2)
        .attr('x2', values['chartDomainX'] + values['chartDomainWidth'])
        .attr('stroke', values['colorScheme']['value'][1])
        .attr('stroke-width', values['axisStrokeWidth'])
        .attr('opacity', 0.5);
      // If minY is 0 or greater draw the X axis at the bottom
      if (values['maxY'] <= 0) {
        yValue = - idx * values['step'];
        steps.attr('y1', yValue)
          .attr('y2', yValue);
        // If 0 is between minY and maxY draw a 0 axis
      } else if (values['minY'] < 0) {
        yValue = values['minY'] + idx * values['step'] <= y0Label ? - idx * values['step'] : values['minY'] + idx * values['step'];
        steps.attr('y1', this.scaleY(yValue))
          .attr('y2', this.scaleY(yValue));
        // If 0 is between minY and maxY draw a 0 axis
      } else {
        yValue = values['minY'] + idx * values['step'];
        steps.attr('y1', this.scaleY(yValue))
          .attr('y2', this.scaleY(yValue));
      }
      let label = g.append('text')
        .attr('id', `step-label${idx}-${this.id}`)
        .attr('text-anchor', 'end')
        .attr('x', values['chartDomainX'] - values['labelOffsetY'])
        .attr('y', this.scaleY(yValue))
        .attr('dominant-baseline', 'middle')
        .attr('fill', values['labelColor'])
        .attr('font-size', values['labelFontSize'])
        .attr('font-family', values['labelFontFamily'] || 'Akko, Akko W01 Regular')
        .text(this.formatNumberDecimals(yValue, values['labelDecimalsY'], values['formatLocale']['value'], ));
    };
  }

  public drawUnitText(selection, values) {
    if (values['drawYAxis']) {
      let yAxisUnit = selection.append('text')
        .attr('id', `yAxisUnit-${this.id}`)
        .attr('x', values['chartDomainX'] + values['labelOffsetY'])
        .attr('text-anchor', 'start')
        .attr('fill', values['labelColor'])
        .attr('font-size', values['labelFontSize'])
        .attr('font-family', values['unitFontFamily'] || 'Akko, Akko W01 Regular')
        .text(values['unitText']);
      // If the Y axis is at the bottom or at 0 draw the unit text at the top
      if (values['maxY'] > 0) {
        yAxisUnit.attr('y', values['chartDomainY'])
          .attr('dy', '0.7em');
        // Otherwise draw it at the top
      } else {
        yAxisUnit.attr('y', values['chartDomainY'] + values['chartDomainHeight']);
      }
    }
  }

  public drawUnitTextSteps(selection, values) {
    let yAxisUnit = selection.append('text')
      .attr('id', `yAxisUnit-${this.id}`)
      .attr('x', values['chartDomainX'] - values['labelOffsetY'])
      .attr('text-anchor', values['labelFontAnchor'] || 'end')
      .attr('fill', values['labelColor'])
      .attr('font-size', values['labelFontSize'])
      .attr('font-family', values['labelFontFamily'] || 'Akko, Akko W01 Regular')
      .text(values['unitText']);
    // If the Y axis is at the bottom or at 0 draw the unit text at the top
    if (values['maxY'] > 0) {
      yAxisUnit.attr('y', this.scaleY(values['maxY']) - values['unitTextOffsetY']);
      // Otherwise draw it at the top
    } else {
      yAxisUnit.attr('y', values['chartDomainY'] + values['chartDomainHeight']);
    }
  }

  public drawXAxisLabels(selection, values, anchor?, leftLabelX?, rightLabelX?) {
    let xAxisLeftLabel = selection.append('text')
      .attr('id', `xAxisLeftLabel-${this.id}`)
      .attr('text-anchor', anchor || 'start')
      .attr('dy', '0.7em')
      .attr('fill', values['labelColor'])
      .attr('font-size', values['xAxisLabelFontSize'] || values['labelFontSize'])
      .attr('font-family', values['labelFontFamily'] || 'Akko, Akko W01 Regular')
      .text(values['leftLabelX']);
    let xAxisRightLabel = selection.append('text')
      .attr('id', `xAxisRightLabel-${this.id}`)
      .attr('x', rightLabelX || values['chartDomainX'] + values['chartDomainWidth'])
      .attr('text-anchor', anchor || 'end')
      .attr('dy', '0.7em')
      .attr('fill', values['labelColor'])
      .attr('font-size', values['xAxisLabelFontSize'] || values['labelFontSize'])
      .attr('font-family', values['labelFontFamily'] || 'Akko, Akko W01 Regular')
      .text(values['rightLabelX']);

    // If minY is 0 or greater draw the X axis labels at the bottom
    if (values['minY'] >= 0) {
      xAxisLeftLabel
        .attr('y', values['chartDomainY'] + values['chartDomainHeight'] + values['labelOffsetX'])
        .attr('x', leftLabelX || values['chartDomainX']);
      xAxisRightLabel
        .attr('y', values['chartDomainY'] + values['chartDomainHeight'] + values['labelOffsetX']);
      // If maxY is 0 or less draw the X axis labels at the top
    } else if (values['maxY'] <= 0) {
      xAxisLeftLabel
        .attr('y', values['chartDomainY'] + values['labelOffsetX'])
        .attr('x', leftLabelX || values['chartDomainX'] + values['labelOffsetY']);
      xAxisRightLabel
        .attr('y', values['chartDomainY'] + values['labelOffsetX']);
      // If 0 is between minY and maxY draw X axis labels at 0
    } else {
      xAxisLeftLabel
        .attr('y', this.scaleY(0) + values['labelOffsetX'])
        .attr('x', leftLabelX || values['chartDomainX'] + values['labelOffsetY']);
      xAxisRightLabel
        .attr('y', this.scaleY(0) + values['labelOffsetX']);
      // And a nice 0 at the Y axis
      if (values['drawYAxis']) {
        selection.append('text')
          .attr('id', `zeroValue-${this.id}`)
          .attr('x', values['chartDomainX'] - values['labelOffsetY'])
          .attr('y', this.scaleY(0))
          .attr('text-anchor', 'end')
          .attr('dy', '0.35em')
          .attr('fill', values['labelColor'])
          .attr('font-size', values['xAxisLabelFontSize'] || values['labelFontSize'])
          .attr('font-family', values['labelFontFamily'] || 'Akko, Akko W01 Regular')
          // .text(values['labelFormatY'] && values['labelFormatY'] !== '' ? numeral(0).format(values['labelFormatY']) : 0)
          .text(this.formatNumberDecimals(0, values['labelDecimalsY'], values['formatLocale']['value'], ));
      }
    }
  }

  // public drawLine(selection, values, data) {
  //   let list = _.map(data, a => a[0]);
  //   let fx = (d, i, data) => this.scaleX(i);
  //   let fy = (d, i, data) => this.scaleY(d);
  //
  //   let line = d3.line();
  //   line.x(fx);
  //   line.y(fy);
  //   let lineString = line(list);
  //   let path = selection.append('path')
  //     .attr('id', `line-${this.id}`)
  //     .attr('d', lineString)
  //     .attr('fill', 'none')
  //     .attr('stroke', values['lineStroke'])
  //     .attr('stroke-width', values['lineStrokeWidth']);
  //   if (values['lineJoin']) {
  //     path.attr('stroke-linejoin', values['lineJoin']['value'])
  //   }
  // }

  public drawLines(selection, values, data) {

    let dataTranpose = _.unzip(data);

    let dataValues = _.filter(data, function(n) {
      return typeof (n[0]) !== 'string';
    });

    let data1 = _.map(dataValues, a => a[0]);

    let fx = (d, i, dataVal) => this.scaleX(i);
    let fy = (d, i, dataVal) => this.scaleY(d);

    let line1 = d3.line();
    line1.x(fx);
    line1.y(fy);

    let lineString1 = line1(data1);
    let path1 = selection.append('path')
      .attr('id', `line1-${this.id}`)
      .attr('d', lineString1)
      .attr('fill', 'none')
      .attr('stroke', values['lineStroke'])
      .attr('stroke-width', values['lineStrokeWidth']);
    if (values['lineJoin']) {
      path1.attr('stroke-linejoin', values['lineJoin']['value'])
    }

    let data2 = [];
    let valueBottom = null;
    if (dataTranpose.length > 1) {
      data2 = _.map(dataValues, a => a[1]);
      valueBottom = data1[data1.length - 1] < data2[data2.length - 1] ? data1[data1.length - 1] : data2[data2.length - 1];

      let fx2 = (d, i, dataVal) => this.scaleX(i);
      let fy2 = (d, i, dataVal) => this.scaleY(d);

      let line2 = d3.line();
      line2.x(fx2);
      line2.y(fy2);
      let lineString2 = line2(data2);
      let path2 = selection.append('path')
        .attr('id', `line2-${this.id}`)
        .attr('d', lineString2)
        .attr('fill', 'none')
        .attr('stroke', this.lightenDarkenColor(values['colorScheme']['value'][1], -20))
        .attr('stroke-width', values['lineStrokeWidth']);
      if (values['lineJoin']) {
        path2.attr('stroke-linejoin', values['lineJoin']['value'])
      }
    }

    if (values['legend']) {
      // console.log('draw legend!');
    } else {
      // draw line labels if exist
      _.map(dataTranpose, (dataMap, index) => {
        let label = dataMap[0];
        if (typeof label === 'string') {
          let offsetY = data[data.length - 1] === valueBottom ? values['offsetBottomLineLabelY'] : - values['offsetTopLineLabelY'];
          let offsetX = data[data.length - 1] === valueBottom ? values['offsetBottomLineLabelX'] : values['offsetTopLineLabelX'];
          let colorLabel = index === 0 ? values['labelColor'] : this.lightenDarkenColor(values['colorScheme']['value'][1], -20);
          let text = selection.append('text')
            .attr('id', `line-label${index}-${this.id}`)
            .attr('text-anchor', 'end')
            .attr('x', values['chartDomainX'] + values['chartDomainWidth'] + offsetX)
            .attr('y', this.scaleY(data[data.length - 1]) + offsetY)
            .attr('alignment-baseline', 'middle')
            .attr('fill', colorLabel)
            .attr('font-size', values['labelFontSize'])
            .attr('font-family', values['lineLabelFontFamily'] || 'Akko, Akko W01 Regular')
            .text(label);
        }
      });

    }
  }

  public drawNLines(selection, values, data) {

    let dataTranpose = _.unzip(data);

    let dataLine;
    let g = selection.append('g')
      .attr('id', `legend-${this.id}`);
    for (let idx = 0; idx < dataTranpose.length; idx++) {
      dataLine = null;
      let line = null;
      dataLine = _.filter(dataTranpose[idx], function(n) {
        return typeof (n) !== 'string';
      });
      let valuesLine = _.compact(dataLine);

      if (valuesLine.length > 1) {
        let fx = (d, i, dataLineVal) => this.scaleX(i);
        let fy = (d, i, dataLineVal) => this.scaleY(d);

        line = d3.line();
        line.x(fx);
        line.y(fy);

        let lineString = line(dataLine);
        let path1 = selection.append('path')
          .attr('id', `line${idx}-${this.id}`)
          .attr('d', line(dataLine))
          .attr('fill', 'none')
          .attr('stroke', values['lineStrokes'][idx])
          .attr('stroke-width', values['lineStrokeWidth']);
        if (values['lineJoin']) {
          path1.attr('stroke-linejoin', values['lineJoin']['value'])
        }
      }
    }

    if (values['legend']) {
      _.map(dataTranpose, (dataMap, index) => {
        let label = dataMap[0];
        let offset2ekolom = index % 2 === 0 ? 0 : values['legendSpaceBetweenColumns'];
        let rij = 1;
        if (index > 1) {
          rij = 2;
        }
        if (typeof label === 'string') {
          let legendLine = g.append('line')
            .attr('id', `legend-line${index}-${this.id}`)
            .attr('x1', values['chartDomainX'] + offset2ekolom)
            .attr('x2', values['chartDomainX'] + values['legendItemWidth'] + offset2ekolom)
            .attr('y1', values['chartDomainY'] + values['chartDomainHeight'] + values['axisStrokeWidth'] / 2 + values['legendOffsetY'] + (rij - 1) * values['legendItemDistance'])
            .attr('y2', values['chartDomainY'] + values['chartDomainHeight'] + values['axisStrokeWidth'] / 2 + values['legendOffsetY'] + (rij - 1) * values['legendItemDistance'])
            .attr('fill', 'none')
            .attr('stroke', values['lineStrokes'][index])
            .attr('stroke-width', values['lineStrokeWidth']);
          let text = g.append('text')
            .attr('id', `legend-label${index}-${this.id}`)
            .attr('text-anchor', 'start')
            .attr('x', values['chartDomainX'] + values['legendItemWidth'] + values['ledgendSpaceBetweenItemAndText'] + offset2ekolom)
            .attr('y', values['chartDomainY'] + values['chartDomainHeight'] + values['axisStrokeWidth'] / 2 + values['legendOffsetY'] + (rij - 1) * values['legendItemDistance'])
            .attr('dy', '0.1em')
            .attr('alignment-baseline', 'middle')
            .attr('fill', values['labelColor'])
            .attr('font-size', values['legendFontSize'])
            .attr('font-family', values['legendFontFamily'] || 'Akko, Akko W01 Regular')
            .text(label);
        }
      });
    }
  }

  public drawBars(selection, values, data, setNumber?) {
    let barHeights = {};
    let list = _.map(data, a => a[0]);
    let base = null;
    let drawBar = null;

    if (values['maxY'] < 0) {
      base = values['maxY'];
    } else if (values['minY'] > 0) {
      base = values['minY'];
    } else {
      base = 0;
    }
    let h = v => Math.abs(v * values['chartDomainHeight'] / (values['maxY'] - values['minY']));

    drawBar = (value, index, setNum?) => {
      let g1 = selection.append('g')
        .attr('transform', `translate(0, ${this.scaleY(base)})`);
      let g2 = g1.append('g');
      if (value >= base) {
        g2.attr('transform', 'scale(1, -1)');
      }
      let id = setNumber === null || setNumber === undefined ? `chart-bars-${this.id}-${index}` : `chart-bars-${this.id}-${setNumber}`;
      barHeights[id] = h(value);
      let bar = g2.append('rect')
        .attr('id', id)
        .classed(`chart-bars-${this.id}`, true)
        .attr('x', this.scaleX(index))
        .attr('y', 0)
        .attr('width', this.scaleX.bandwidth())
        .attr('height', h(value))
        .attr('fill', values['barColor'])
        .attr('data-value', value);
      if (values['barStrokeWidth'] > 0) {
        bar.attr('stroke', values['barStrokeColor']);
        bar.attr('stroke-width', values['barStrokeWidth']);
      } else {
        bar.attr('stroke', 'none');
      }
    };

    _.map(list, (value, index) => {
      drawBar(value, index, setNumber);
    });

    return barHeights;
  }

  public drawHorizontalBars(selection, values, data, isStill?) {
    let barIDs = [];
    let barWidths = {};
    let list = _.map(data, a => a[1]);
    let base = null;
    let xOffset = values['minX'] < 0 && !isStill ? this.scaleX(0) : values['chartDomainX'];
    let drawBar = null;
    if (values['maxX'] < 0) {
      base = values['maxX'];
    } else if (values['minX'] > 0) {
      base = values['minX'];
    } else {
      base = 0;
    }
    let w = v => Math.abs(v * values['chartDomainWidth'] / (values['maxX'] - values['minX']));

    drawBar = (value, index) => {
      let g1 = selection.append('g')
        .attr('transform', `translate(${xOffset})`, 0);
      let g2 = g1.append('g');
      // let id = setNumber === null || setNumber === undefined ? `chart-bars-horiz-${this.id}-${index}` : `chart-bars-horiz-${this.id}-${setNumber}-${index}`;
      let id = `chart-bars-horiz-${this.id}-${index}`;

      if (value < base) {
        g2.attr('transform', 'scale(-1, 1)');
      }
      barWidths[id] = w(value);
      let bar = g2.append('rect')
        .attr('id', id)
        .classed(`chart-bars-horiz-${this.id}`, true)
        .attr('x', 0)
        .attr('y', this.scaleY(index))
        .attr('width', w(value))
        .attr('height', this.scaleY.bandwidth())
        .attr('fill', values['barColor'])
        .attr('data-value', value);
      if (values['barStrokeWidth'] > 0) {
        bar.attr('stroke', values['barStrokeColor']);
        bar.attr('stroke-width', values['barStrokeWidth']);
      } else {
        bar.attr('stroke', 'none');
      }
    };

    _.map(list, (value, index) => {
      drawBar(value, index);
    });

    return barWidths;
  }

  public animateAxes(timeline, values, rightLabelX?) {

    if (values['maxY'] > 0) {
      timeline.fromTo(`#yAxis-${this.id}`, 1, { drawSVG: '0%' }, { drawSVG: '100%' }, 'startAxes')
        .from(`#yAxisTopValue-${this.id}`, 0.1, { attr: { opacity: 0 }, delay: 0.05 }, 'startAxes')
        .from(`#yAxisTopValue-${this.id}`, 1, { attr: { y: values['chartDomainY'] + values['chartDomainHeight'] } }, 'startAxes');
    } else {
      timeline.fromTo(`#yAxis-${this.id}`, 1, { drawSVG: '100% 100%' }, { drawSVG: '100% 0%' }, 'startAxes')
        .from(`#yAxisBottomValue-${this.id}`, 0.1, { attr: { opacity: 0 }, delay: 0.05 }, 'startAxes')
        .from(`#yAxisBottomValue-${this.id}`, 1, { attr: { y: values['chartDomainY'] } }, 'startAxes');
    }
    timeline.fromTo(`#xAxis-${this.id}`, 1, { drawSVG: '0%' }, { drawSVG: '100%' }, 'startAxes')
      .from(`#xAxisRightLabel-${this.id}`, 0.1, { attr: { opacity: 0 }, delay: 0.05 }, 'startAxes')
      .from(`#xAxisRightLabel-${this.id}`, 1, { attr: { x: values['chartDomainX'] } }, 'startAxes')

    if (values['minY'] < 0 && values['maxY'] > 0) {
      timeline.fromTo(`#zeroValue-${this.id}`, 0.1, { attr: { opacity: 0 } }, { attr: { opacity: 1 }, delay: 0.05 }, 'startAxes')
        .from(`#zeroValue-${this.id}`, 1, { attr: { y: values['chartDomainY'] + values['chartDomainHeight'] } }, 'startAxes');
    }
  }

  public animateYAxis(timeline, values) {
    timeline.from(`#yAxis-${this.id}`, 1, { attr: { y1: values['chartDomainY'] } }, 'startYAxes');
  }

  public animateXAxis(timeline, values) {

    timeline.fromTo(`#xAxis-${this.id}`, 1, { drawSVG: '0%' }, { drawSVG: '100%' }, 'startXAxes')
      // .fromTo(`#xAxisLeftLabel-${this.id}`, 0.1, { attr: { opacity: 0 } }, { attr: { opacity: 1 }, delay: 0.05 }, 'startXAxes')
      // .fromTo(`#xAxisRightLabel-${this.id}`, 0.1, { attr: { opacity: 0 } }, { attr: { opacity: 1 }, delay: 0.05 }, 'startXAxes')
      // .fromTo(`#xAxisRightLabel-${this.id}`, 1, { attr: { x: values['chartDomainX'] } }, { attr: { x: values['chartDomainX'] + values['chartDomainWidth'] } }, 'startXAxes');
      .fromTo(`#xAxisLeftLabel-${this.id}`, 0.1, { attr: { opacity: 0 } }, { attr: { opacity: 1 } }, 'startXAxes')
      .fromTo(`#xAxisRightLabel-${this.id}`, 0.1, { attr: { opacity: 0 } }, { attr: { opacity: 1 } }, 'startXAxes')
      .from(`#xAxisRightLabel-${this.id}`, 1, { attr: { x: values['chartDomainX'] } }, 'startXAxes');
  }

  public animateSteps(timeline, values) {
    let maxAnimationSteps = 50; // bij meer dan 50 steps, worden deze niet meer geanimeerd
    timeline.fromTo(`#xAxis-${this.id}`, 1, { attr: { opacity: 0 } }, { attr: { opacity: 1 } }, 'startXAxes')
      .fromTo(`#xAxisLeftLabel-${this.id}`, 1, { attr: { opacity: 0 } }, { attr: { opacity: 1 } }, 'startXAxes')
      .fromTo(`#xAxisRightLabel-${this.id}`, 1, { attr: { opacity: 0 } }, { attr: { opacity: 1 } }, 'startXAxes')
      .fromTo(`#step-label0-${this.id}`, 1, { attr: { opacity: 0 } }, { attr: { opacity: 1 } }, `startXAxes`);

    if (values['maxY'] <= 0) {
      for (let idx = 1; idx <= values['steps'] && values['steps'] < maxAnimationSteps; idx++) {
        timeline.fromTo(`#step-label${idx}-${this.id}`, 1, { attr: { y: this.scaleY(-(idx - 1) * values['step']), opacity: 0 } }, { attr: { y: this.scaleY(- idx * values['step']), opacity: 1 } }, idx, 'startXAxes')
          .fromTo(`#step${idx}-${this.id}`, 1, {
            attr: {
              y1: this.scaleY(-(idx - 1) * values['step']),
              y2: this.scaleY(-(idx - 1) * values['step'])
            }
          }, { attr: { y1: this.scaleY(- idx * values['step']), y2: this.scaleY(- idx * values['step']) } }, idx, 'startXAxes')
      }
    } else if (values['minY'] < 0) {
      let y0Label = values['maxY'] < 0 ? values['maxY'] : values['minY'] > 0 ? values['minY'] : 0;
      for (let idx = 1; idx <= values['steps'] && values['steps'] < maxAnimationSteps; idx++) {
        let yValue = values['minY'] + idx * values['step'] <= y0Label ? - idx * values['step'] : values['minY'] + idx * values['step'];
        timeline.fromTo(`#step-label${idx}-${this.id}`, 1, { attr: { y: this.scaleY(0), opacity: 0 } }, { attr: { y: this.scaleY(yValue), opacity: 1 } }, idx, 'startXAxes')
          .fromTo(`#step${idx}-${this.id}`, 1, {
            attr: {
              y1: this.scaleY(0),
              y2: this.scaleY(0)
            }
          }, { attr: { y1: this.scaleY(yValue), y2: this.scaleY(yValue) } }, idx, 'startXAxes')
      }
    } else {
      for (let idx = 1; idx <= values['steps'] && values['steps'] < maxAnimationSteps; idx++) {
        timeline.fromTo(`#step-label${idx}-${this.id}`, 1, {
          attr: {
            y: this.scaleY(values['minY'] + (idx - 1) * values['step']),
            opacity: 0
          }
        }, { attr: { y: this.scaleY(values['minY'] + idx * values['step']), opacity: 1 } }, idx, `startstep${idx}`)
          .fromTo(`#step${idx}-${this.id}`, 1, {
            attr: {
              y1: this.scaleY(values['minY'] + (idx - 1) * values['step']),
              y2: this.scaleY(values['minY'] + (idx - 1) * values['step']),
              opacity: 0
            }
          }, { attr: { y1: this.scaleY(values['minY'] + idx * values['step']), y2: this.scaleY(values['minY'] + idx * values['step']), opacity: 0.5 } }, idx, `startstep${idx}`)
      }
    }
  }

  public animateUnit(timeline, values) {
    timeline.fromTo(`#yAxisUnit-${this.id}`, 1, { attr: { opacity: 0 } }, { attr: { opacity: 1 } }, 'startUnit');
    timeline.fromTo(`#xAxisUnit-${this.id}`, 1, { attr: { opacity: 0 } }, { attr: { opacity: 1 } }, 'startUnit');
  }

  // public animateLine(timeline, values) {
  //   timeline.fromTo(`#line-${this.id}`, 1, { drawSVG: '0%' }, { drawSVG: '100%' }, 'startLine');
  // }

  public animateLineOfLines(timeline, values, idx) {
    let idString = `startLine${idx}`;
    timeline.fromTo(`#line${idx}-${this.id}`, 1, { drawSVG: '0%' }, { drawSVG: '100%' }, `startLine${idx}`)
      .from(`#line-label${idx - 1}-${this.id}`, 1, { attr: { opacity: 0 }, delay: 1 }, `startLine${idx}`);
    return timeline;
  }

  public animateNLines(timeline, values, data) {
    for (let idx = 0; idx < data[0].length; idx++) {
      let idString = `line${idx}`;
      timeline.fromTo(`#line${idx}-${this.id}`, 1, { drawSVG: '0%' }, { drawSVG: '100%' }, `line${idx}`);
      // if (values['legend']){
      //   timeline.fromTo(`#legend${idx}-${this.id}`, 1, { drawSVG: '0%' }, { drawSVG: '100%' }, `line${idx}`);
      //   timeline.from(`#legend-label${idx}-${this.id}`, 1, { opacity: 0 }, `line${idx}`);
      // }
    }
    return timeline;
  }

  public animateLegend(timeline, values) {
    if (values['legend']) {
      timeline.fromTo(`#legend-${this.id}`, 1, { opacity: 0 }, { opacity: 1 }, `legendStart`);
    }
    return timeline;
  }

  public animateBars(timeline, values, bars) {
    let ids = _.keys(bars);
    switch (values['barAnimation']['value']) {
      case 'allAtOnce':
        let barHeight;
        for (let idx = 0; idx < ids.length; idx++) {
          // barHeight = bars[`chart-bars-${this.id}-${idx}`];
          timeline.from(`#chart-bars-${this.id}-${idx}`, 1, { attr: { height: '0' } }, 'startBars');
        }
        break;
      case 'oneAfterTheOther':
        timeline.staggerFrom(`.chart-bars-${this.id}`, 1, { attr: { height: '0' } }, 0.1, 'startBars');
        break;
      default:
        timeline.from(`.chart-bars-${this.id}`, 1, { attr: { height: '0' } }, 'startBars');
    }
  }

  public showDebugValues() {
    console.log('bannerHeight : ' + this.values['bannerHeight']);
    console.log('backgroundPaneHeight : ' + this.values['backgroundPaneHeight']);
    console.log('chartPaneX : ' + this.values['chartPaneX']);
    console.log('chartPaneY : ' + this.values['chartPaneY']);
    console.log('chartPaneWidth : ' + this.values['chartPaneWidth']);
    console.log('chartPaneHeight : ' + this.values['chartPaneHeight']);
    console.log('chartDomainX : ' + this.values['chartDomainX']);
    console.log('chartDomainY : ' + this.values['chartDomainY']);
    console.log('chartDomainWidth : ' + this.values['chartDomainWidth']);
    console.log('chartDomainHeight : ' + this.values['chartDomainHeight']);
  }
}





// WEBPACK FOOTER //
// ./src/app/animations/animation-base-classes/basic-chart.component.ts